import styled from 'styled-components';

export const ButtonContainer = styled.div`
  max-width: 150px;
`;
